/*eslint-disable*/
import React from 'react';
import { Card, CardHeader, CardBody, Row, Col, CardTitle, Button } from 'reactstrap';
import DataGrid, { MasterDetail, Column, Paging, Format, Export } from 'devextreme-react/data-grid';
import { number } from 'prop-types';
import { numberFormat } from 'highcharts';

export default class CapacidadDispDescGrid extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            pageIndexTab4: 0
        };

        this.dataGrid = null;

        this.handleOptionChange = this.handleOptionChange.bind(this);   
    }
    
    handleOptionChange(e) {
        if (e.fullName === 'paging.pageIndexTab4') {
          this.props.onPage(e.value);
        }
    }
    
    render() {
        const gridContent = (
            <Row>
                <Col>
                    <Row>    
                        <Col>
                            <DataGrid
                                id="gridCapacidadDescDisp"
                                ref={(ref) => this.dataGrid = ref}
                                dataSource={this.props.capacidadDispDescData}
                                key={'ClaUbicacion'}
                                width="100%"
                                height={600}
                                selection={{ mode: 'single' }}
                                showBorders={false}
                                columnHidingEnabled
                                columnAutoWidth={false}
                                showColumnHeaders
                                showColumnLines={false}
                                showRowLines
                                noDataText="Sin Registros"
                                wordWrapEnabled
                                rowAlternationEnabled={false}
                                allowColumnResizing={true}
                                onOptionChanged={this.handleOptionChange}
                            >

                                <Column dataField="NomUbicacion" caption="Ubicación" width={40}/>
                                <Column dataField="NomZona" caption="Zona" width={40}/>
                                <Column dataField="CapacidadDescargaUbi" caption="Capacidad" width={20}/>
                                <Column dataField="CapDispDescargaLunes" caption="Lunes" width={20}/>
                                <Column dataField="CapDispDescargaMartes" caption="Martes" width={20}/>
                                <Column dataField="CapDispDescargaMiercoles" caption="Miércoles" width={20}/>
                                <Column dataField="CapDispDescargaJueves" caption="Jueves" width={20}/>
                                <Column dataField="CapDispDescargaViernes" caption="Viernes" width={20}/>
                                <Column dataField="CapDispDescargaSabado" caption="Sábado" width={20}/>
                                <Column dataField="CapDispDescargaDomingo" caption="Domingo" width={20}/>
                                <Column width={1}/>

                                <Paging
                                    pageSize={30}
                                    pageIndexTab4={this.props.pageIndexTab4}
                                />
                            </DataGrid>
                        </Col>
                    </Row>
                </Col>
            </Row>
        );

        return (
        <>
            {gridContent}
        </>
        );
    }
}